import { useState } from "react";
import "./BacklightToggle.scss";

const DEFAULT_LABEL = "Check it out";
const DEFAULT_OPTIONS = [
    { key: "on", label: "ON", state: "backlit_on" },
    { key: "off", label: "OFF", state: "backlit_off" },
];

const BacklightToggle = ({ config }) => {
    const toggleLabel = config?.label || DEFAULT_LABEL;
    const OPTIONS = config?.options && config.options.length ? config.options : DEFAULT_OPTIONS;

    const [isOn, setIsOn] = useState(false);

    const applyState = (optionKey) => {
        const option = OPTIONS.find((o) => o.key === optionKey);

        if (
            option &&
            window.scene &&
            typeof window.scene.groupApplyState === "function"
        ) {
            window.scene.groupApplyState(option.state);
        }
    };

    const handleToggle = () => {
        const nextState = !isOn;
        const optionKey = nextState ? "on" : "off";

        applyState(optionKey);
        setIsOn(nextState);
    };

    const currentOption = OPTIONS.find((o) => o.key === (isOn ? "on" : "off"));
    const displayText = currentOption ? currentOption.label : (isOn ? "ON" : "OFF");

    return (
        <div className="backlightToggle" onClick={(e) => e.stopPropagation()}>
            <div className="toggleLabel">
                {toggleLabel}
            </div>
            <div
                className={`toggleTrack ${isOn ? "on" : "off"}`}
                onClick={handleToggle}
                role="button"
                tabIndex={0}
                aria-checked={isOn}
                aria-label="Backlight toggle"
                onKeyDown={(e) => e.key === "Enter" && handleToggle()}
            >
                <div className="toggleInnerPill">
                    <span className="toggleText">{displayText}</span>
                    <div className="toggleKnob"></div>
                </div>
            </div>
        </div>
    );
};

export default BacklightToggle;